import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import TextBox from "components/common/TextBox";
import styles from "./TextBoxGroup.scss";

/**
 * TextBoxGroup component
 * Renders a group of TextBox components for handling a collection of text inputs.
 */
const TextBoxGroup = ({
    fields,
    onChange,
    values = {},
    disabled = false,
    textBoxProps = {},
    heading = "",
}) => {
    const [localValues, setLocalValues] = useState({});

    const handleFieldValueChange = useCallback((data, idx) => {
        setLocalValues(prevValues => ({ ...prevValues, [data.name]: data.value }));
    }, []);

    useEffect(() => {
        if (onChange) {
            onChange({ name: "answer", value: localValues });
        }
    }, [localValues]);

    if (!Array.isArray(fields) || fields.length === 0) {
        return null;
    }

    return (
        <div>
            {heading && <p className={styles.heading}>{heading}</p>}
        <div className={styles.root}>
            {fields.map((field, idx) => {
                const fieldName = field.name || field;
                const fieldKey = typeof field === 'string' ? field : fieldName;
                return (
                    <TextBox
                        key={`${fieldKey}-${idx}`}
                        name={fieldName}
                        label={field.label || field}
                        value={values[fieldName] !== undefined ? values[fieldName] : ""}
                        onChange={onChange ? (data) => handleFieldValueChange(data, idx) : undefined}
                        disabled={disabled || field.disabled}
                        placeholder={field.placeholder || field}
                        {...textBoxProps}
                    />
                );
            })}
        </div>
        </div>
    );
};

TextBoxGroup.propTypes = {
    fields: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
                disabled: PropTypes.bool,
                placeholder: PropTypes.string,
            })
        ])
    ),
    onChange: PropTypes.func,
    values: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    disabled: PropTypes.bool,
    textBoxProps: PropTypes.object,
    heading: PropTypes.string,
};

export default TextBoxGroup;
